import React from 'react'
import './MenuIdiomasH.css'

import { connect } from 'react-redux'
import { getMenu, toggleOpenMenu } from '../../modules/reducer'

import { useSpring, animated } from 'react-spring'

import {gaEvent} from '../../Cookies'

const MenuIdiomasH = ({ history, visible, idioma, path, toggleOpenMenu }) => {
  const { opacity, right } = useSpring({
    opacity: visible ? 1 : 0,
    right: visible ? '9em' : '5em'
  })

  return (
    <animated.div
      className="menu-h"
      style={{
        opacity,
        right
      }}
    >
      <div
        className="menu-h-a"
        style={{
          fontWeight: idioma === 'en' ? 500 : 300
        }}
        onClick={e => {
          gaEvent({
            category: 'Selección idioma',
            action: 'Inglés'
          })
          history.push(`/en/${path}`)
          toggleOpenMenu()
        }}
      >
        ENGLISH
      </div>
      |
      <div
        className="menu-h-a"
        style={{
          fontWeight: idioma === 'es' ? 500 : 300
        }}
        onClick={e => {
          gaEvent({
            category: 'Selección idioma',
            action: 'Español'
          })
          history.push(`/es/${path}`)
          toggleOpenMenu()
        }}
      >
        ESPAÑOL
      </div>
    </animated.div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  const menu = getMenu(reducer)

  return {
    visible: reducer.openMenu,
    idioma: menu.idioma,
    path: menu.path
  }
}

const mapDispatchToProps = { toggleOpenMenu }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuIdiomasH)
